export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';
export const UPDATE_USER_DATA = 'UPDATE_USER_DATA';
export const USER_COOKIE = 'user';
export const RESET_CART = 'RESET_CART';
